import { Component } from "@angular/core";
import { NavController, NavParams } from "ionic-angular";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { User } from "../../providers/user";
import { ToastController } from "ionic-angular/components/toast/toast-controller";

export class ResetDetails {
  email: string;
  password: string;
  password2: string;
  code: string;
}

@Component({
  selector: "page-reset",
  templateUrl: "reset.html"
})
export class ResetPage {
  public resetDetails: ResetDetails;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private user: User
  ) {
    this.resetDetails = new ResetDetails();
    if (this.user != null && this.user.getUser() != null) {
      this.resetDetails.email = this.user.getUser().getUsername();
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad ResetPage");
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  getCode() {
    if (this.resetDetails.email.length < 2) {
      let toast = this.toastCtrl.create({
        message: "Please enter email or username.",
        duration: 3000
      });
      toast.present();
      return;
    }
    this.user
      .sendResetCode(this.resetDetails.email)
      .then(data => {
        let toast = this.toastCtrl.create({
          message: "Reset code requested to " + data,
          duration: 3000
        });
        toast.present();
      })
      .catch(err => {
        let toast = this.toastCtrl.create({
          message: "Error requesting code: " + err.message,
          duration: 3000
        });
        toast.present();
      });
  }

  doReset() {
    if (
      this.resetDetails.password !== this.resetDetails.password2 ||
      this.resetDetails.password === ""
    ) {
      let toast = this.toastCtrl.create({
        message: "Passwords do not match.",
        duration: 3000
      });
      console.log("Passwords do not match.");
      toast.present();
      return;
    }

    this.user
      .resetPassword(
        this.resetDetails.email,
        this.resetDetails.code,
        this.resetDetails.password
      )
      .then(data => {
        let toast = this.toastCtrl.create({
          message: "Password reseet.",
          duration: 3000
        });
        toast.present();
        console.log("Password reset");
        this.dismiss();
      })
      .catch(err => {
        let toast = this.toastCtrl.create({
          message: "Error resetting password: " + err.message,
          duration: 3000
        });
        toast.present();
        console.log("Error resetting password: " + err.message);
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/reset/reset.ts